module.exports = __webpack_public_path__ + "static/avatar.07320eb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jpg/avatar.jpg
// module id = 175
// module chunks = 114276838955818 198517197184460